export default {
  'user.title': 'Account',
  'user.persona': 'Personal data',
  'user.name': 'Name',
  'user.birthday': 'Date of birth',
  'user.password': 'Password',
  'user.password.description': 'Change password',
  'user.email': 'Email',
  'user.phone': 'Phone number',
  'user.contact': 'Contact',

  'user.verification': 'Email verification',
  'user.verified': 'Email was confirmed',
  'user.not-verified': 'Email confirmation pending. Click here to resend the email.',
  'user.not-verified.resent':
    'Verification email has been sent. Renewed e-mail delivery is no longer possible.',

  'change-password': 'Change password',
  'change-password.success': 'Password was changed successfully',
  'change-password.success.description': 'Please log in again',
  'change-password.old-password': 'Old password',
  'change-password.new-password': 'New password',
  'change-password.new-password.repeat': 'Repeat new password',
  'change-password.required-field': 'Please fill in all indicated fields',

  'account-details': 'Account information',

  'set-new-password': 'Set new password',
  'set-new-password.description': 'Please enter your new password twice.',

  // Reset password
  'reset-password.sent': 'Please check your mailbox',
  'reset-password.success': 'Password was reset',
  'reset-password.sent.description':
    'If an account already exists with the e-mail address you entered, a link to reset the password will be sent to this address.',
  'reset-password': 'Reset password',
  'reset-password.error':
    'Your password could not be reset. Please check the email address you entered.',
  'reset-password.description':
    'Please enter the email address you used to create the account. You will receive an email with a link to reset.',
  'prepare-password-reset.error':
    'Your password could not be reset. Please check the email address you entered.',
  'prepare-password-reset.title': 'Reset password',
  'prepare-password.reset.description':
    'Please enter the email address you used to create the account. You will receive an email with a link to reset.',
};
